import { render, staticRenderFns } from "./TenancyAllContactsEdit.vue?vue&type=template&id=36642210&"
import script from "./TenancyAllContactsEdit.vue?vue&type=script&lang=js&"
export * from "./TenancyAllContactsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36642210')) {
      api.createRecord('36642210', component.options)
    } else {
      api.reload('36642210', component.options)
    }
    module.hot.accept("./TenancyAllContactsEdit.vue?vue&type=template&id=36642210&", function () {
      api.rerender('36642210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/edit/TenancyAllContactsEdit.vue"
export default component.exports